<template>
    <a-modal v-model="visible" title="导入报价单" width="800px" ok-text="提交" class="import-plan-modal" :mask-closable="false" @cancel="onCancel" @ok="onSubmit">
        <div v-loading="uploading">
            <a-alert message="当“始发仓/目的仓/车型”完全相同时，将会覆盖原有报价信息，请仔细核对后进行导入" banner />
            <block-title title="下载模板" class="block" :show-line="false">
                <div class="batchBtnStyle batch-file" @click="downloadTemplate">
                    <div>
                        <img class="icon-xlsx" src="@/assets/img/icon/icon_xlsx.png" />
                        线路报价导入模板
                    </div>
                    <img class="icon_load cursor" src="@/assets/img/icon/icon_download.png" />
                </div>
            </block-title>

            <block-title title="选择文件" class="block" :show-line="false">
                <div class="item-content">
                    <div class="content-upload">
                        <a-upload :show-upload-list="false" :before-upload="beforeUpload">
                            <a-button class="uploadBtn" :disabled="uploading" type="primary">
                                <img class="uploadStyle" src="@/assets/img/icon/upload.png" alt="" />
                                {{ selectFileBtnTxt }}
                            </a-button>
                        </a-upload>
                    </div>
                    <p class="upload-tip">单次上传最大不超过10000条数据，文件大小最大不超过10M，文件格式支持xlsx,xls</p>
                    <div v-if="file" class="filename batch-file">
                        <div>
                            <img class="filenameLeft" src="@/assets/img/icon/icon_file.png" alt="" />
                            {{ file.name }}
                        </div>
                        <img class="filenameRight cursor" src="@/assets/img/icon/icon_lajitong.png" alt="" @click="removeFile" />
                    </div>
                </div>
            </block-title>
        </div>
        <template #footer>
            <a-button key="back" :loading="uploading" @click="onCancel">取消</a-button>
            <a-button key="submit" type="primary" :loading="uploading" @click="onSubmit">提交</a-button>
        </template>
    </a-modal>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue';
import { getFileNameSuffix } from '@/utils/handleFile.js';
import { importQuotation, getConfig, importInboundQuotation } from '../../api';

export default {
    name: 'ImportPlan',
    components: {
        BlockTitle
    },
    data() {
        return {
            form: null,
            visible: false,
            file: null,
            uploading: false,
            // 文件最大10M
            fileMaxSize: 1024 * 1024 * 10,
            // 文件类型暂时只支持 .xlsx
            fileTypeLimit: ['.xlsx', '.xls'],
            disabled: null,
            downLoadUrl: null
        };
    },
    computed: {
        selectFileBtnTxt() {
            return !this.file ? '选择文件' : '重新选择';
        }
    },
    methods: {
        beforeUpload(file) {
            this.file = file;
            this.validateFile(file);
            return false;
        },
        // 校验文件格式
        validateFile(file) {
            const { fileMaxSize, fileTypeLimit } = this;
            const fileSize = file.size;
            const fileType = getFileNameSuffix(file.name);
            if (!fileTypeLimit.includes(fileType)) {
                this.file = null;
                this.$message.error('文件格式仅支持xlsx,xls');
                return;
            }
            if (fileSize > fileMaxSize) {
                this.file = null;
                this.$message.error('文件最大不超过10M');
            }
        },
        show(form) {
            this.form = form || null;
            this.visible = true;
            if (form && form.type == '1') {
                this.downLoadUrl = 'https://prod-ylzapp-public.oss-cn-zhangjiakou.aliyuncs.com/1054/cus_plan_origin_excel/线路报价导入模板-直接运输.xlsx';
            } else {
                this.downLoadUrl = 'https://prod-ylzapp-public.oss-cn-zhangjiakou.aliyuncs.com/1004/cus_template/干线组网价格导入模板.xlsx';
                // this.getConfigFn();
            }
        },
        removeFile() {
            this.file = null;
        },
        onCancel() {
            this.visible = false;
            this.uploading = false;
            this.file = null;
        },
        async getConfigFn() {
            const data = await getConfig({
                appId: '1002',
                keys: ['download_quotaion_template']
            });
            this.downLoadUrl = data.configs[0].value || 'https://ylzapp-pub-test.oss-cn-zhangjiakou.aliyuncs.com/1004/cus_template/line_v1.xlsx';
        },
        async onSubmit() {
            const { file } = this;
            if (!file) {
                this.$message.warning('请选择需要上传的文件');
                return;
            }
            if (this.disabled) {
                return;
            }
            this.disabled = true;
            const formData = new FormData();
            formData.append('file', file);
            this.uploading = true;
            try {
                formData.append('customerCode', this.$store.state.user.tenantId);
                if (this.form.type == '1') {
                    await importInboundQuotation(formData);
                } else {
                    await importQuotation(formData);
                }
                this.$message.success('上传文件成功');
                this.uploading = false;
                this.visible = false;
                this.disabled = false;
                this.file = null;
                this.$emit('handleSuccess');
            } catch (e) {
                console.log('报错', e);
            } finally {
                this.uploading = false;
                setTimeout(() => {
                    this.disabled = false;
                }, 3000);
            }
        },
        downloadTemplate() {
            // eslint-disable-next-line no-underscore-dangle
            if (window.__POWERED_BY_WUJIE__) {
                window.open(this.downLoadUrl);
            } else {
                window.location.href = this.downLoadUrl;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.import-plan-modal {
    ::v-deep .ant-modal-body {
        padding: 10px 20px 32px 20px;
        box-sizing: border-box;
        .ant-alert-banner {
            background: #ffefde;
            .ant-alert-message {
                color: #fb9432;
            }
        }
    }
    .block {
        margin-top: 32px;
        > div {
            margin-left: 32px;
        }
        .batch-file {
            border-radius: 4px;
            width: 456px;
            height: 64px;
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .batchBtnStyle {
            background: #f2fbf8;
            margin-bottom: 32px;
            cursor: pointer;
            .icon-xlsx {
                width: 46px;
                height: 46px;
                margin-right: 16px;
            }
            .icon_load {
                width: 24px;
                height: 24px;
            }
        }
        .item-content {
            .uploadBtn {
                width: 160px;
                height: 32px;
                background: #06b880;
                border-radius: 2px;
                .uploadStyle {
                    margin-right: 12px;
                }
            }
            .upload-tip {
                margin-top: 16px;
                color: #a9abae;
            }
            .filename {
                margin-top: 32px;
                border: 1px solid #ebedf0;
            }
        }
        .cursor {
            cursor: pointer;
        }
    }
}
</style>
